<template>
<div>
  <b-container>
    <b-row>
      <b-col cols="8" style="">
        <div id="toppy">
          <h3>Products</h3>
          <b-btn size="md" pill v-b-modal.productModal variant="info" style="">
            <span class="">
              <i class="fas fa-plus" />
            </span>
            <!-- Product -->
          </b-btn>
        </div>
      </b-col>
    </b-row>
    </b-row>
    <b-row>
      <b-col cols="8">

        <b-table small hover :items="products" :fields="tableFields">
          <template slot="actions" slot-scope="data">
            <span class="btn btn-sm" @click="editProduct(data.item.productId)" style="color: orange;">
              <i class="fas fa-edit" />
            </span>
            <span class="btn btn-sm" @click="rmProduct(data.item.productId)" style="color:red;">
              <i class="fas fa-trash" />
            </span>
          </template>
          <!-- <template slot="name" slot-scope="data">
        {{data.value}} -->
          <!-- {{data.value.first}} {{data.value.last}} -->
          <!-- <template slot="FOOT_name" slot-scope="data"> -->
          <!-- A custom formatted footer cell  for field 'name' -->
          <!-- <strong>hello</strong> -->
          <!-- </template> -->
        </b-table>
      </b-col>
      <b-col>

      </b-col>
    </b-row>
    <ProductModal/>
    <EditProductModal :id="editProductId"/>
  </b-container>
</div>
</template>

<script>
import ProductModal from '@/components/ProductModal'
import EditProductModal from '@/components/EditProductModal'
let exProduct = {
  productTitle: 'atmos X Kaw',
  price: 33,
  totalStock: 55,
  productId: 'xa'

}
let exProducts = [exProduct]
let tableFields = [{
    key: 'productTitle',
    label: 'Title'
  },
  'price',
  'totalStock',
  'actions'
]
export default {
  name: 'Products',
  components: {
    ProductModal,
    EditProductModal
  },
  created() {
    this.$store.dispatch('products/getProducts')
  },
  computed: {
    products() {
      return this.$store.state.products.products
    }
  },
  data() {
    return {
      exProducts,
      tableFields,
      editProductId: null,
    }
  },
  methods: {
    editProduct(productId) {
      console.log(`editing product ${productId}`)
      let product = this.products.find(p => p.productId == productId)
      if(!product) return console.error(`no product with id ${productId}`)
      // console.log(`found product data`,product)
      this.editProductId = productId
      this.$bvModal.show('editProductModal')
    },
    rmProduct(productId) {
      console.log(`removing product ${productId}`)
      this.$store.dispatch('products/deleteProduct',productId)
    }
  }

}
</script>
<style scoped lang="stylus">
.round-btn
  border-radius: 100px;
#toppy
  display: flex
  justify-content: space-between;
  margin: 5px;
</style>
